<template>
  <v-dialog v-model="dialogVisible" max-width="400px">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>
        {{ content }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="cancelButtonColor" text @click="cancel">{{
          cancelButtonText
        }}</v-btn>
        <v-btn :color="confirmButtonColor" text @click="confirm">{{
          confirmButtonText
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: 'Confirmación'
  },
  content: {
    type: String,
    default: '¿Estás seguro de que quieres realizar esta acción?'
  },
  cancelButtonText: {
    type: String,
    default: 'Cancelar'
  },
  confirmButtonText: {
    type: String,
    default: 'Confirmar'
  },
  cancelButtonColor: {
    type: String,
    default: 'blue darken-1'
  },
  confirmButtonColor: {
    type: String,
    default: 'red darken-1'
  }
})

const emit = defineEmits(['update:modelValue', 'cancel', 'confirm'])

const dialogVisible = ref(props.modelValue)

watch(
  () => props.modelValue,
  (newValue) => {
    dialogVisible.value = newValue
  }
)

watch(dialogVisible, (newValue) => {
  emit('update:modelValue', newValue)
})

const cancel = () => {
  emit('cancel')
  dialogVisible.value = false
}

const confirm = () => {
  emit('confirm')
  dialogVisible.value = false
}
</script>
